import React, {useState, memo, useEffect} from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';

import './index.css'

const TABLE_HEADER = [
    'name',
    'time',
    'bytes received per second',
    'bytes sent per second',
    'bytes total per second',
    'bandwidth'
]

const SumoTable = ({ list }) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    return (
        <div className="sumo-table">
            <TableContainer component={Paper}>
                <Table className="table" size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            {
                                TABLE_HEADER
                                    .map((headerRow) => <TableCell key={headerRow} align="center">{headerRow}</TableCell> )
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,index) => (
                            <TableRow key={`${row.name}${index}`}>
                                <TableCell component="th" scope="row">
                                    {row.name}
                                </TableCell>
                                <TableCell align="center">{row.timeStamp}</TableCell>
                                <TableCell align="center">{row.bytesReceivedPerSecond}</TableCell>
                                <TableCell align="center">{row.bytesSentPerSecond}</TableCell>
                                <TableCell align="center">{row.bytesSentPerSecond}</TableCell>
                                <TableCell align="center">{row.currentBandwidth}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                className="table-pagination"
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={list.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    )
}

export default memo(SumoTable);
